export default "__VITE_ASSET__d92216fc__"